import { IdMap, RArray } from "../collections";
import { toPairs } from "../core";
import { makeImmutable } from "../core/makeImmutable";
import { PMenuSectionItemParser } from "../parsing";
import { PMenu } from "../presentation/PMenu";
import { PRestaurant } from "../presentation/PRestaurant";
import { PCustomParameterTypeParser, PMenuSectionParser, PModifierTypeParser, PProductTypeParser, VariantCreatorFactory, } from "./presentation";
export class PRestaurantParser {
    constructor(params) {
        this.localizationProvider = params.localizationProvider;
        this.checkoutInfoService = params.checkoutInfoService;
        this.translatedParser = params.translatedParser;
        makeImmutable(this);
    }
    parse(params) {
        const domainMenu = params.domainRestaurant.menu;
        const customParameterTypeParser = new PCustomParameterTypeParser({
            domainCustomParameterTypes: domainMenu.customParameterTypes,
            translatedParser: this.translatedParser,
        });
        const customParameterTypes = this.parseCustomParameterTypes(params.input.catalogue, customParameterTypeParser);
        const modifierTypeParser = new PModifierTypeParser({
            domainModifiers: domainMenu.modifierTypes,
            translatedParser: this.translatedParser,
        });
        // FIXME How to choose correct menu arragment?
        const menuArragment = domainMenu.arrangments.sample;
        if (menuArragment === null) {
            throw new Error("No menu sections defined");
        }
        const modifierTypes = this.parseModifierTypes(params.input.catalogue, modifierTypeParser);
        const productTypeParser = new PProductTypeParser({
            domainProductTypes: domainMenu.productTypes,
            domainSchedules: domainMenu.schedules,
            translatedParser: this.translatedParser,
            modifierTypes,
        });
        const productTypes = this.parseProductTypes(params.input.catalogue, productTypeParser);
        const variantCreatorFactory = new VariantCreatorFactory({
            productCategories: domainMenu.productCategories,
            productTypes: domainMenu.productTypes,
            purchaseOrderScope: params.purchaseOrderScope,
        });
        const pMenuSectionItemParser = new PMenuSectionItemParser({
            productTypes,
            customParameterTypes,
            localizationProvider: this.localizationProvider,
            variantCreatorFactory,
            purchaseOrderPayload: params.purchaseOrderPayload,
        });
        const menuSectionParser = new PMenuSectionParser({
            domainMenuSections: menuArragment.sections,
            domainSchedules: domainMenu.schedules,
            translatedParser: this.translatedParser,
            pMenuSectionItemParser,
        });
        return new PRestaurant({
            domain: params.domainRestaurant,
            name: params.input.name,
            address: params.input.address,
            menu: new PMenu({
                domain: domainMenu,
                sections: this.parseSections(params.input.catalogue, menuSectionParser),
            }),
            productTypes,
            modifierTypes,
            customParameterTypes,
            promotionTypes: params.promotionTypes,
            isApplePaySupported: this.checkoutInfoService.isApplePaySupported,
            orderingAvailability: params.orderingAvailability,
        });
    }
    parseProductTypes(catalogue, parser) {
        return IdMap.fromIterable(toPairs(catalogue.products).mapOptional(([productId, product]) => {
            const productCategory = catalogue.categories[product.category];
            return parser.parse(productId, productCategory.name, product);
        }));
    }
    parseModifierTypes(catalogue, parser) {
        return IdMap.fromIterable(toPairs(catalogue.modifiers).mapOptional(([modifierId, modifier]) => parser.parse(modifierId, modifier)));
    }
    parseCustomParameterTypes(catalogue, parser) {
        return IdMap.fromIterable(toPairs(catalogue.customParameters).mapOptional(([customParameterId, customParameter]) => parser.parse(customParameterId, customParameter)));
    }
    parseSections(catalogue, parser) {
        const sections = new RArray(toPairs(catalogue.menus).raw.flatMap(([_, menu]) => menu.sections)).mapOptional((sectionId) => {
            const section = catalogue.sections[sectionId];
            return parser.parse(sectionId, section);
        });
        return IdMap.fromIterable(sections);
    }
}
